module.exports = __webpack_public_path__ + "static/media/mod_tacan_turbos.8eaaa2b9.usdz";